import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RadioButtonClickEvent } from 'primeng/radiobutton';

@Component({
  selector: 'app-radio',
  templateUrl: './radio.component.html',
})
export class RadioComponent {
  @Input() options: any[] = [];
  @Input() inline: boolean = false;
  @Input() selectedValue: string = '';
  @Input() for?: string;
  @Output() sendValueChange = new EventEmitter();

  onClick(event: RadioButtonClickEvent) {
    this.sendValueChange.emit(event);
  }
}
